import guardsForModel from "./forTBuilderModel";
import { AllDataTemplates } from "../../requests/templateBuilder/types";
import { DataTemplateGroups } from "../modelGroups/otherModelGroups";
import makeGuardsForModelSubset from "../makeGuardsForModelSubset";

type SchemaKey = keyof typeof guardsForModel;
type CompleteUnion = AllDataTemplates;
type Groups = DataTemplateGroups;

const criteria = <Key extends SchemaKey>(
  key: SchemaKey,
  dataTemplate: CompleteUnion
): dataTemplate is Groups[Key] => {
  const { parentTemplateBuilderModel } = dataTemplate;
  return guardsForModel[key](parentTemplateBuilderModel);
};

const guardsForSubset = makeGuardsForModelSubset<
  CompleteUnion,
  SchemaKey,
  Groups
>(criteria);

export default guardsForSubset;
